import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { map, mergeMap, skipWhile, take } from 'rxjs/operators';

import * as settingSelectors from '../../settings/store/selectors/setting.selector';
import { ReferenceValueSheet } from '../models/reference-value-sheet.model';
import { ReferenceValueSheetService } from '../services/reference-value-sheet.service';
import * as refValSheetActions from '../store/reference-value-sheet.actions';

@Injectable()
export class GetReferenceValueSheetByIdResolver {
  private refValSheetService = inject(ReferenceValueSheetService);
  private store = inject<Store<RootState>>(Store);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  resolve(route: ActivatedRouteSnapshot) {
    const path = route.pathFromRoot
      .map((v) => v.url.map((segment) => segment.toString()).join('/'))
      .join('/');
    if (path.indexOf('standard') > -1) {
      this.store.dispatch(refValSheetActions.loadStandardRefValSheetData());
    } else {
      this.store.dispatch(refValSheetActions.loadRefValSheetData());
    }

    return combineLatest([this.store.select(settingSelectors.getRVSSettings)]).pipe(
      skipWhile(([rvsSettings]) => rvsSettings === undefined),
      mergeMap(([rvsSettings]) =>
        this.refValSheetService.getReferenceValueSheetById(
          Number(route.paramMap.get('id')),
          rvsSettings,
        ),
      ),
      take(1),
      map((refValSheet: ReferenceValueSheet) => refValSheet),
    );
  }
}
